import { Dispatch } from 'react';
import { request } from './request';
import { SessionAction } from '../interfaces/Session';

interface PostTokenProps {
  username: string,
  personName: string,
  password: string,
  totp: string,
  emailTOTP: boolean,
}

export function postToken(dispatch: Dispatch<SessionAction>, props: PostTokenProps) {
  return request(dispatch, '/auth/token', {
    auth: false,
    method: 'POST',
    body: {
      ...props,
      grant_type: 'password',
    },
  });
}